// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","text":"Hero_text__ht4xS","img":"Hero_img__oWQHK","getStarted":"Hero_getStarted__yz90i"};